import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { FadeIn } from "@/components/FadeIn";

export default function PageHero({ crumb, line1, line2, subtitle, children }) {
  return (
    <section data-testid="page-hero" className="relative bg-[#070604] overflow-hidden pt-[72px] md:pt-20">
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden="true" />
      <div className="absolute top-[-30%] right-[10%] w-[45vw] h-[45vw] rounded-full bg-[#c9a14a]/[0.07] blur-[120px] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <FadeIn>
          <div className="flex items-center gap-2 text-[10px] font-bold tracking-[0.24em] uppercase text-[#c9a14a]">
            <Link to="/" className="text-[#f7f2e8]/60 hover:text-[#c9a14a] transition-colors">Home</Link>
            <ChevronRight size={11} className="text-[#f7f2e8]/40" />
            <span>{crumb}</span>
          </div>
          <h1 className="mt-5 font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.06]">
            <span className="block text-[#f7f2e8]">{line1}</span>
            <span className="block text-[#c9a14a]">{line2}</span>
          </h1>
          {subtitle && (
            <p className="mt-6 text-[#f7f2e8]/80 text-base md:text-lg leading-relaxed max-w-lg">{subtitle}</p>
          )}
        </FadeIn>
        {children}
      </div>
    </section>
  );
}
